var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "message-traffic-chart",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _vm.fullScreen
        ? _c(
            "div",
            { staticClass: "title" },
            [
              _c("ChartDoddleIcon"),
              _vm._v(" "),
              _c("h2", [_vm._v("WABA Message Traffic")]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: "Chart View" },
                      expression: "{ content: 'Chart View' }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: "Table View" },
                      expression: "{ content: 'Table View' }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: "Download" },
                      expression: "{ content: 'Download' }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: "Fullscreen" },
                      expression: "{ content: 'Fullscreen' }",
                    },
                  ],
                  attrs: { onClick: _vm.switchToFullScreenMode },
                },
                [
                  !_vm.fullScreen
                    ? _c("md-icon", [_vm._v("fullscreen")])
                    : _c("md-icon", [_vm._v("fullscreen_exit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      !_vm.tableMode
        ? _c("EChartsLine", {
            attrs: {
              labels: _vm.getXAxisLabels(),
              datasets: _vm.getChartDatasets(),
              height: 320,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "stats" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }